import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const PRIORITIES = ["High", "Medium", "Low"];
export const PRIORITY_STYLE = {
  High: "bg-red-100 text-red-700", Medium: "bg-amber-100 text-amber-700", Low: "bg-stone-100 text-stone-500",
};
export const priorityRank = (p) => ({ High: 0, Medium: 1, Low: 2 }[p] ?? 1);

// Compact priority select + assigned-staff + next-follow-up controls for a CRM table row.
export const CrmControls = ({ lead, onUpdate, testidPrefix }) => (
  <div className="flex flex-col gap-1.5">
    <Select value={lead.priority || "Medium"} onValueChange={(v) => onUpdate(lead.id, { priority: v })}>
      <SelectTrigger data-testid={`${testidPrefix}-priority-${lead.id}`} className={`h-7 w-24 rounded-full border-0 text-xs font-semibold ${PRIORITY_STYLE[lead.priority || "Medium"]}`}><SelectValue /></SelectTrigger>
      <SelectContent>{PRIORITIES.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}</SelectContent>
    </Select>
    <Input defaultValue={lead.assigned_staff} onBlur={(e) => e.target.value !== (lead.assigned_staff || "") && onUpdate(lead.id, { assigned_staff: e.target.value })} placeholder="Staff…" className="h-7 w-28 rounded-lg text-xs" data-testid={`${testidPrefix}-staff-${lead.id}`} />
    <Input type="date" defaultValue={(lead.next_follow_up || "").slice(0, 10)} onBlur={(e) => e.target.value !== (lead.next_follow_up || "").slice(0, 10) && onUpdate(lead.id, { next_follow_up: e.target.value })} className="h-7 w-32 rounded-lg text-xs" data-testid={`${testidPrefix}-followup-${lead.id}`} />
  </div>
);
